import { TokenType } from '@/constants/types/misc/Auth';

type PostHogLike = {
  identify: (id: string, props?: Record<string, unknown>) => void;
  register: (props: Record<string, unknown>) => void;
};

/**
 * Ties the browser to the logged-in seller and tags every event (pageviews,
 * exceptions, web vitals, replays) with the tenant. posthog-js dedupes repeat
 * calls with the same id and props, so this is safe to run on every navigation.
 */
export function identifyFromToken(
  posthog: PostHogLike,
  token: TokenType | undefined
) {
  if (!token?.email) return;
  const tenant = {
    schemaName: token['custom:schema_name'],
    subsidiaryId: token['custom:subsidiary_id'],
  };
  posthog.register(tenant);
  posthog.identify(token.email, {
    email: token.email,
    name: [token.name, token.family_name].filter(Boolean).join(' '),
    supplier: token['custom:supplier_name'],
    subsidiary: token['custom:subsidiary_name'],
    ...tenant,
  });
}
